/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { setAnalytics } from '../../../utils';

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.card,
    borderRadius: 10,
    margin: theme.spacing(0, 0, 2, 0),
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.background.hoverCard,
    },
  },
  cardDisabled: {
    background: '#ff99991f',
    borderRadius: 10,
    margin: theme.spacing(0, 0, 2, 0),
  },
  cardSelected: {
    background: '#1A3758',
    color: theme.palette.text.default,
    margin: theme.spacing(0, 0, 2, 0),
    borderRadius: '10px',
    border: '1px solid #FCD050',
    cursor: 'pointer',
  },
  cardEvaluationText: {
    fontFamily: 'Raleway',
    padding: theme.spacing(1, 0),
    color: theme.palette.text.default,
  },
  cardEvaluationTextDisabled: {
    color: '#7e7777',
    fontFamily: 'Raleway',
    padding: theme.spacing(1, 0),
  },
}));
function PracticalCard({ practical }) {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [classNameToCard, setClassNameToCard] = useState('');
  const {
    topic, course, nameCourse, finalProjectUserId, idUser,
    idTopicUser, completedLesson, quizzId, quizzStatus, practicalStatus,
  } = location.state;

  const navigatePracticalView = () => {
    navigate('/lesson', {
      state: {
        topic,
        course,
        nameCourse,
        practicalId: practical[0].id,
        practicalStatus: practical[0].status,
        practical: true,
        finalProjectUserId,
        idUser,
        idTopicUser,
        completedLesson,
        quizzId,
        quizzStatus,
      },
    });
    setClassNameToCard(classes.cardSelected);
  };

  const getClassNameToCard = () => {
    if (practical[0].status === false) {
      setClassNameToCard(classes.cardDisabled);
    }
    if (practicalStatus && location.state.practical) {
      setClassNameToCard(classes.cardSelected);
    }
  };

  useEffect(() => {
    getClassNameToCard();
    setAnalytics('Caso Práctico', 'Btn_EnviarCasoPractico');
  }, []);
  return (
    <Card
      className={practicalStatus && location.state.practical === undefined
        ? classes.card : classNameToCard}
      onClick={() => (practicalStatus ? navigatePracticalView() : null)}
    >
      <CardContent>
        <Typography className={practicalStatus ? classes.cardEvaluationText
          : classes.cardEvaluationTextDisabled}
        >
          Caso Práctico

        </Typography>
      </CardContent>
    </Card>
  );
}

export default PracticalCard;

PracticalCard.propTypes = {
  practical: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]))).isRequired,
};
